import "flowbite";
import { initFlowbite } from "flowbite";
import { Cursor } from "./js/Cursor";
import { CreateSubmission } from "./js/CreateSubmission";
import { UpdateSubmission } from "./js/UpdateSubmission";
import { AskExpert } from "./js/AskExpert";
import { CreateModal } from "./js/CreateModal";
import { FilterTable } from "./js/Filter";
import { Login } from "./js/Login";
import { SmoothPageScroll } from "./js/SmoothPageScroll";
import { Editor } from "./js/Editor";
import { ChooseToggles } from "./js/ChooseToggles";
import { SystemStatus } from "./js/SystemStatus";
import { DownloadPDF } from "./js/DownloadPDF";
import { RemoveEmptyRows } from "./js/RemoveEmptyRows";
import { FinaliseSubmission } from "./js/FinaliseSubmission";
import { SendReminders } from "./js/SendReminders";
import { SubmissionTabs } from "./js/SubmissionTabs";
import { RangeSliders } from "./js/RangeSliders";
import { CreateJobDescription } from "./js/CreateJobDescription";
import { UpdateSubmissionStatus } from "./js/UpdateSubmissionStatus";

window.tabs = null;

const init = () => {

  window.scrollTo(0, 0);
  
  let lenis = SmoothPageScroll();
  let wysiwyg = new Editor("#skillEditor");
  let wysiwyg2 = new Editor("#ratingObjectivesEditor");
  let wysiwyg3 = new Editor("#noteEditor");
  let wysiwyg4 = new Editor("#noteEditor2");
  let wysiwyg5 = new Editor("#customObjectivesJobDescription");

  Login();
  AskExpert();
  SystemStatus();
  FinaliseSubmission();
  DownloadPDF();

  CreateModal("modalAddNote", lenis, wysiwyg3);
  CreateModal("modalAddSkill", lenis, wysiwyg);
  CreateModal("modalAddSkillCategory", lenis);
  CreateModal("modalAddLineManager", lenis);
  CreateModal("modalAddRatingObjectives", lenis, wysiwyg2);
  CreateModal("modalEditNote", lenis, wysiwyg4);

  CreateSubmission();
  UpdateSubmission();
  UpdateSubmissionStatus();
  CreateJobDescription(wysiwyg5);
  SendReminders();

  FilterTable("searchSubmissions", "tableSubmissions", ".table-filter");
  FilterTable("searchSkills", "tableSkills");
  FilterTable("searchUsers", "tableUsers");

  new ChooseToggles('input[name*="_user_develop"]', 3);
  new ChooseToggles('input[name*="_user_specialist"]', 1);
  new RemoveEmptyRows("#comparison");
  new Cursor(".js-cursor");

  SubmissionTabs();
  initFlowbite();
  RangeSliders();

};

document.addEventListener("DOMContentLoaded", init);
// Transitions(init); - weird logout bug in wordpress i can't solve
